export default "__VITE_ASSET__$v4v5Oio__"